export type Nationality = {
  code: string
  name: string
}

const ALL_NATIONALITIES: Nationality[] = [
	{ code: "AD", name: "Andorra" },
	{ code: "AE", name: "Forenede Arabiske Emirater (UAE)" },
	{ code: "AF", name: "Afghanistan" },
	{ code: "AG", name: "Antigua and Barbuda" },
	{ code: "AI", name: "Anguilla" },
	{ code: "AL", name: "Albanien" },
	{ code: "AM", name: "Armenien" },
	{ code: "AO", name: "Angola" },
	{ code: "AQ", name: "Antarctica" },
	{ code: "AR", name: "Argentina" },
	{ code: "AS", name: "Amerikansk Samoa" },
	{ code: "AT", name: "Østrig" },
	{ code: "AU", name: "Australien" },
	{ code: "AW", name: "Aruba" },
	{ code: "AX", name: "Åland Islands" },
	{ code: "AZ", name: "Aserbajdsjan" },
	{ code: "BA", name: "Bosnien-Hercegovina" },
	{ code: "BB", name: "Barbados" },
	{ code: "BD", name: "Bangladesh" },
	{ code: "BE", name: "Belgien" },
	{ code: "BF", name: "Burkina - Faso" },
	{ code: "BG", name: "Bulgarien" },
	{ code: "BH", name: "Bahrain" },
	{ code: "BI", name: "Burundi" },
	{ code: "BJ", name: "Benin" },
	{ code: "BL", name: "Saint Barthélemy" },
	{ code: "BM", name: "Bermuda" },
	{ code: "BN", name: "Brunei Darussalam" },
	{ code: "BO", name: "Bolivia (Plurinational State of)" },
	{ code: "BQ", name: "Bonaire, Sint Eustatius and Saba" },
	{ code: "BR", name: "Brasilien" },
	{ code: "BS", name: "Bahamas" },
	{ code: "BT", name: "Bhutan" },
	{ code: "BV", name: "Bouvet Island" },
	{ code: "BW", name: "Botswana" },
	{ code: "BY", name: "Hviderusland (Belarus)" },
	{ code: "BZ", name: "Belize" },
	{ code: "CA", name: "Canada" },
	{ code: "CC", name: "Cocos (Keeling) Islands (the)" },
	{ code: "CD", name: "Congo, den Demokratiske republik" },
	{ code: "CF", name: "Den Centralafrikanske republik" },
	{ code: "CG", name: "Congo (the)" },
	{ code: "CH", name: "Schweiz" },
	{ code: "CI", name: "Elfenbenskysten" },
	{ code: "CK", name: "Cook Islands (the)" },
	{ code: "CL", name: "Chile" },
	{ code: "CM", name: "Cameroun" },
	{ code: "CN", name: "Kina" },
	{ code: "CO", name: "Colombia" },
	{ code: "CR", name: "Costa Rica" },
	{ code: "CU", name: "Cuba" },
	{ code: "CV", name: "Cabo Verde" },
	{ code: "CW", name: "Curaçao" },
	{ code: "CX", name: "Christmas Island" },
	{ code: "CY", name: "Cypern" },
	{ code: "CZ", name: "Tjekkiet" },
	{ code: "DE", name: "Tyskland" },
	{ code: "DJ", name: "Djibouti" },
	{ code: "DK", name: "Danmark" },
	{ code: "DM", name: "Dominica" },
	{ code: "DO", name: "Den Dominikanske Republik" },
	{ code: "DZ", name: "Algeriet" },
	{ code: "EC", name: "Ecuador" },
	{ code: "EE", name: "Estland" },
	{ code: "EG", name: "Egypten" },
	{ code: "EH", name: "Vestsahara" },
	{ code: "ER", name: "Eritrea" },
	{ code: "ES", name: "Spanien" },
	{ code: "ET", name: "Ethiopien" },
	{ code: "FI", name: "Finland" },
	{ code: "FJ", name: "Fiji" },
	{ code: "FK", name: "Falkland-øerne" },
	{ code: "FM", name: "Mikronesien" },
	{ code: "FO", name: "Færøerne" },
	{ code: "FR", name: "Frankrig" },
	{ code: "GA", name: "Gabon" },
	{ code: "GB", name: "Storbritannien (England)" },
	{ code: "GD", name: "Grenada" },
	{ code: "GE", name: "Georgien" },
	{ code: "GF", name: "Fransk Guyana" },
	{ code: "GG", name: "Guernsey" },
	{ code: "GH", name: "Ghana" },
	{ code: "GI", name: "Gibraltar" },
	{ code: "GL", name: "Grønland" },
	{ code: "GM", name: "Gambia" },
	{ code: "GN", name: "Guinea" },
	{ code: "GP", name: "Guadalupe" },
	{ code: "GQ", name: "Ækvatorial Guinea" },
	{ code: "GR", name: "Grækenland" },
	{ code: "GS", name: "South Georgia and the South Sandwich Islands" },
	{ code: "GT", name: "Guatemala" },
	{ code: "GU", name: "Guam" },
	{ code: "GW", name: "Guinea - Bissau" },
	{ code: "GY", name: "Guyana" },
	{ code: "HK", name: "Hong Kong" },
	{ code: "HM", name: "Heard- & McDonald-øerne" },
	{ code: "HN", name: "Honduras" },
	{ code: "HR", name: "Kroatien" },
	{ code: "HT", name: "Haiti" },
	{ code: "HU", name: "Ungarn" },
	{ code: "ID", name: "Indonesien" },
	{ code: "IE", name: "Irland" },
	{ code: "IL", name: "Israel" },
	{ code: "IM", name: "Isle Of Man" },
	{ code: "IN", name: "Indien" },
	{ code: "IO", name: "British Indian Ocean Territory (the)" },
	{ code: "IQ", name: "Irak" },
	{ code: "IR", name: "Iran" },
	{ code: "IS", name: "Island" },
	{ code: "IT", name: "Italien" },
	{ code: "JE", name: "Jersey" },
	{ code: "JM", name: "Jamaica" },
	{ code: "JO", name: "Jordan" },
	{ code: "JP", name: "Japan" },
	{ code: "KE", name: "Kenya" },
	{ code: "XK", name: "Kosovo" },
	{ code: "KG", name: "Kyrgyzstan" },
	{ code: "KH", name: "Cambodia" },
	{ code: "KI", name: "Kiribati" },
	{ code: "KM", name: "Comoros (the)" },
	{ code: "KN", name: "Saint Kitts and Nevis" },
	{ code: "KP", name: "Nord-Korea" },
	{ code: "KR", name: "Syd Korea (Republic)" },
	{ code: "KW", name: "Kuwait" },
	{ code: "KY", name: "Caymanøerne" },
	{ code: "KZ", name: "Kazakhstan" },
	{ code: "LA", name: "Laos" },
	{ code: "LB", name: "Libanon" },
	{ code: "LC", name: "Saint Lucia" },
	{ code: "LI", name: "Liechtenstein" },
	{ code: "LK", name: "Sri Lanka" },
	{ code: "LR", name: "Liberia" },
	{ code: "LS", name: "Lesotho" },
	{ code: "LT", name: "Litauen" },
	{ code: "LU", name: "Luxembourg" },
	{ code: "LV", name: "Letland" },
	{ code: "LY", name: "Libyen" },
	{ code: "MA", name: "Marokko" },
	{ code: "MC", name: "Monaco" },
	{ code: "MD", name: "Moldova" },
	{ code: "ME", name: "Montenegro" },
	{ code: "MF", name: "Saint Martin (Franske del)" },
	{ code: "MG", name: "Madagascar" },
	{ code: "MH", name: "Marshall Islands" },
	{ code: "MK", name: "Makedonien (Nordmakedonien)" },
	{ code: "ML", name: "Mali" },
	{ code: "MM", name: "Myanmar (Burma)" },
	{ code: "MN", name: "Mongoliet" },
	{ code: "MO", name: "Macao" },
	{ code: "MP", name: "Northern Mariana Islands (the)" },
	{ code: "MQ", name: "Martinique" },
	{ code: "MR", name: "Mauritania" },
	{ code: "MS", name: "Montserrat" },
	{ code: "MT", name: "Malta" },
	{ code: "MU", name: "Mauritius" },
	{ code: "MV", name: "Maldiverne" },
	{ code: "MW", name: "Malawi" },
	{ code: "MX", name: "Mexico" },
	{ code: "MY", name: "Malaysia" },
	{ code: "MZ", name: "Mozambique" },
	{ code: "NA", name: "Namibia" },
	{ code: "NC", name: "Ny Kaledonien" },
	{ code: "NE", name: "Niger" },
	{ code: "NF", name: "Norfolk Island" },
	{ code: "NG", name: "Nigeria" },
	{ code: "NI", name: "Nicaragua" },
	{ code: "NL", name: "Nederlandene (Holland)" },
	{ code: "NO", name: "Norge" },
	{ code: "NP", name: "Nepal" },
	{ code: "NR", name: "Nauru" },
	{ code: "NU", name: "Niue" },
	{ code: "NZ", name: "New Zealand" },
	{ code: "OM", name: "Oman" },
	{ code: "PA", name: "Panama" },
	{ code: "PE", name: "Peru" },
	{ code: "PF", name: "Fransk Polynesien" },
	{ code: "PG", name: "Papua Ny Guinea" },
	{ code: "PH", name: "Philippinerne" },
	{ code: "PK", name: "Pakistan" },
	{ code: "PL", name: "Polen" },
	{ code: "PM", name: "Saint Pierre and Miquelon" },
	{ code: "PN", name: "Pitcairn-øerne" },
	{ code: "PR", name: "Puerto Rico" },
	{ code: "PS", name: "Palæstina" },
	{ code: "PT", name: "Portugal" },
	{ code: "PW", name: "Palau" },
	{ code: "PY", name: "Paraguay" },
	{ code: "QA", name: "Quatar" },
	{ code: "RE", name: "Reunion" },
	{ code: "RO", name: "Rumænien" },
	{ code: "RS", name: "Serbien" },
	{ code: "RU", name: "Rusland" },
	{ code: "RW", name: "Rwanda" },
	{ code: "SA", name: "Saudi Arabien" },
	{ code: "SB", name: "Solomon Islands" },
	{ code: "SC", name: "Seychellerne" },
	{ code: "SD", name: "Sudan" },
	{ code: "SE", name: "Sverige" },
	{ code: "SG", name: "Singapore" },
	{ code: "SH", name: "Saint Helena, Ascension and Tristan da Cunha" },
	{ code: "SI", name: "Slovenien" },
	{ code: "SJ", name: "Svalbard and Jan Mayen" },
	{ code: "SK", name: "Slovakiet" },
	{ code: "SL", name: "Sierra Leone" },
	{ code: "SM", name: "San Marino" },
	{ code: "SN", name: "Senegal" },
	{ code: "SO", name: "Somalia" },
	{ code: "SR", name: "Suriname" },
	{ code: "SS", name: "Syd Sudan" },
	{ code: "ST", name: "Sao Tome and Principe" },
	{ code: "SV", name: "El Salvador" },
	{ code: "SX", name: "Sint Marteen (Hollandske del)" },
	{ code: "SY", name: "Syrien" },
	{ code: "SZ", name: "Swaziland (Eswatini)" },
	{ code: "TC", name: "Turks and Caicos Islands (the)" },
	{ code: "TD", name: "Chad" },
	{ code: "TF", name: "Franske Sydlige Territorier" },
	{ code: "TG", name: "Togo" },
	{ code: "TH", name: "Thailand" },
	{ code: "TJ", name: "Tajikistan" },
	{ code: "TK", name: "Tokelau" },
	{ code: "TL", name: "Timor-Leste" },
	{ code: "TM", name: "Turkmenistan" },
	{ code: "TN", name: "Tunesien" },
	{ code: "TO", name: "Tonga" },
	{ code: "TR", name: "Tyrkiet" },
	{ code: "TT", name: "Trinidad and Tobago" },
	{ code: "TV", name: "Tuvalu" },
	{ code: "TW", name: "Taiwan" },
	{ code: "TZ", name: "Tanzania" },
	{ code: "UA", name: "Ukraine" },
	{ code: "(UA)", name: "Krim og Sevastopol (Ukraine)" },
	{ code: "UG", name: "Uganda" },
	{ code: "UM", name: "United States Minor Outlying Islands (the)" },
	{ code: "US", name: "USA" },
	{ code: "UY", name: "Uruguay" },
	{ code: "UZ", name: "Usbekistan" },
	{ code: "VA", name: "Vatikanet (The Holy See)" },
	{ code: "VC", name: "Saint Vincent and the Grenadines" },
	{ code: "VE", name: "Venezuela" },
	{ code: "VG", name: "British Virgin Islands" },
	{ code: "VI", name: "US Virgin Islands" },
	{ code: "VN", name: "Vietnam" },
	{ code: "VU", name: "Vanuatu" },
	{ code: "WF", name: "Wallis and Futuna" },
	{ code: "WS", name: "Samoa" },
	{ code: "YE", name: "Yemen" },
	{ code: "YT", name: "Mayotte" },
	{ code: "ZA", name: "Syd Afrika (Republic of/)" },
	{ code: "ZM", name: "Zambia" },
	{ code: "ZW", name: "Zimbabwe" }
]

export const getNationalities = async (): Promise<Nationality[]> => {
  return [...ALL_NATIONALITIES].sort((a, b) =>
    a.name.toUpperCase().localeCompare(b.name.toUpperCase())
  )
}
